var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVariant3 = function SvgVariant3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 172 174"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2015",
    d: "M9.619 74.367c0-39.3 54.03-53.818 93.147-53.818S148 64.965 148 104.265 97.243 153 58.126 153 9.62 113.666 9.62 74.367"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#variant3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#variant3_svg__b)",
    fillOpacity: 0.3,
    d: "M40.882 4.561c28.542 3.756 83.522 9.855 83.522 9.855.047 1.01.066 1.968.066 2.884-.001.326-.42 1.012-.42 1.012s.402.537.394.824c-.023.897-.06 1.752-.1 2.57-.011.228-1.294.795-1.294.795s1.238.301 1.227.509c-.188 3.644-.318 6.6.689 9.613l-.439 8.824c-44.97-4.806-92.55-12.624-92.55-12.624 3.697-4.188.142-3.43 1.934-7.24.12-.256.99-.538 1.12-.823.137-.297-.353-.737-.037-1.302.834-1.488 2.104-3.744 2.819-5.908.096-.291.762-.649.762-.649l-.199-1.047.758-2.26 1.13-1.461-.06-1.634z",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#variant3_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#variant3_svg__d)",
    fillOpacity: 0.3,
    d: "M20.879 100.621c23.735 16.291 69.97 46.661 69.97 46.661q-.624 1.378-1.249 2.599c-.148.291-.832.712-.832.712s.114.661-.023.913c-.428.79-.848 1.534-1.255 2.246-.113.197-1.514.121-1.514.121s.967.83.864 1.01c-1.821 3.163-3.278 5.739-3.746 8.881l-4.393 7.664c-37.9-24.677-76.762-53.222-76.762-53.222 5.195-2.056 1.682-2.992 5.008-5.576.223-.173 1.126-.031 1.371-.225.257-.202.02-.817.558-1.177 1.418-.949 3.573-2.383 5.191-3.987.218-.216.974-.233.974-.233l.297-1.024 1.7-1.67 1.67-.79.687-1.483z",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "variant3_svg__b",
    x1: 32.349,
    x2: 123.198,
    y1: 20.936,
    y2: 28.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "variant3_svg__d",
    x1: 5.848,
    x2: 83.455,
    y1: 111.346,
    y2: 159.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "variant3_svg__a",
    width: 94.99,
    height: 39.886,
    x: 30.976,
    y: 4.561,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_82_4542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_82_4542",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_82_4542"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "variant3_svg__c",
    width: 90.91,
    height: 73.808,
    x: 0.939,
    y: 100.621,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_82_4542"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_82_4542",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_82_4542"
  })))));
};
export default SvgVariant3;